import React from "react";
import BaseButton from "./BaseButton";

/** Cancel is a way out, not a destructive action — so it stays tertiary. */
const BaseCancel = (props) => (
  <BaseButton type="text" { ...props }>
    { props.text || "Cancel" }
  </BaseButton>
);

export default BaseCancel;
